import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { FaFileImport, FaFilter, FaUsers, FaBoxOpen } from "react-icons/fa"
import {
  MdCurrencyPound,
  MdDownload,
  MdImportExport,
  MdReport,
  MdSpeed,
} from "react-icons/md"
import Loader from "components/Loader/loader"
import Select from "react-select"
import Gauge from "./GuageChart"
import { FaProductHunt } from "react-icons/fa6"
import BarChart from "./peakbarchart"
import SuccessRateChart from "./SuccessRateChart"
import SalesChart from "./SalesChart"
import OrderBarChart from "./OrderBarChart"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import { customStyles } from "utils/SelectStyles"
import { months } from "utils/defaultpositions"
import { DatePicker } from "antd"
import secureLocalStorage from "react-secure-storage"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import moment from "moment"
import { getPreviousSaturday } from "utils/dateUtil"
import dayjs from "dayjs"

const { RangePicker } = DatePicker

const Dashboard = props => {
  document.title = "Dashboard | Robinsons"

  const fileInputRef = useRef(null)

  const [loading, setLoading] = useState(false)
  // const [activeTab, setActiveTab] = useState("sales")
  const [importModal, setImportModal] = useState(false)
  const [selectedType, setSelectedType] = useState("")
  const [importFile, setImportFile] = useState(null)
  const [error, setError] = useState("")
  const [currentweek, setCurrentWeek] = useState([])

  const [importDropdown, setImportDropdown] = useState(false)
  const [maxDate, setMaxDate] = useState("")

  const [dateRange, setDateRange] = useState([])
  const [selectedMonths, setSelectedMonths] = useState([])
  const [selectedYears, setSelectedYears] = useState([])

  const [dateRange1, setDateRange1] = useState([])
  const [selectedMonths1, setSelectedMonths1] = useState([])
  const [selectedYears1, setSelectedYears1] = useState([])

  // YEAR DROPDOWN (2021 → current year)
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: currentYear - 2020 }, (_, i) => ({
    label: `${2021 + i}`,
    value: 2021 + i,
  }))

  const [oee, setOee] = useState("")
  const [gmp, setGmp] = useState("")
  const [sales, setSales] = useState("")
  const [PL, setPL] = useState("0")
  const [netPL, setNetPL] = useState("0")

  const [dashboardData1, setDashboardData1] = useState({})

  const [ranges, setRanges] = useState([])

  useEffect(() => {
    const currentWeekDate = async () => {
      const APIdata = await fetchData(setLoading, "sheet/latest/week")
      if (APIdata?.success) {
        const DateRange = [
          APIdata?.data?.gmpDate?.date,
          getPreviousSaturday(APIdata?.data?.gmpDate?.date),
        ]
        const PLDateRange = [
          APIdata?.data?.plDate?.date,
          getPreviousSaturday(APIdata?.data?.plDate?.date),
        ]

        // Compare and take the lower (earlier) start date
        const lowerStartDate =
          new Date(DateRange[0]) >= new Date(PLDateRange[0])
            ? DateRange[0]
            : PLDateRange[0]

        setMaxDate(moment(lowerStartDate, "YYYY-MM-DD"))

        const finalRange = [
          dayjs(getPreviousSaturday(lowerStartDate)),
          dayjs(lowerStartDate),
        ]

        setDateRange(finalRange)
        setDateRange1(finalRange)
        setCurrentWeek(finalRange)

        secureLocalStorage.removeItem("KPIWEEK"),
          secureLocalStorage.removeItem("PLWEEK"),
          secureLocalStorage.removeItem("FINALRANGE"),
          secureLocalStorage?.setItem("KPIWEEK", JSON.stringify(DateRange))
        secureLocalStorage?.setItem("PLWEEK", JSON.stringify(PLDateRange))
        secureLocalStorage?.setItem("FINALRANGE", finalRange)

        Swal.fire({
          title: "Latest Week Details",
          icon: "info",
          html: `
    <div style="text-align:left; font-size:13px; display:flex; flex-direction:column; gap:10px;">

      <div style="display:flex; align-items:center; justify-content:space-between; background:#eff6ff; border:1px solid #bfdbfe; border-radius:10px; padding:10px 14px;">
        <div style="display:flex; align-items:center; gap:8px;">
          <span style="width:8px;height:8px;border-radius:50%;background:#3b82f6;display:inline-block;"></span>
          <span style="font-weight:700; color:#1e40af;">KPI Sheet</span>
        </div>
        <span style="font-weight:600; color:#1e3a8a; font-family:monospace;">
          ${dayjs(DateRange?.[1]).format("DD-MM-YYYY")}
          &nbsp;→&nbsp;
          ${dayjs(DateRange?.[0]).format("DD-MM-YYYY")}
        </span>
      </div>

      <div style="display:flex; align-items:center; justify-content:space-between; background:#f0fdf4; border:1px solid #bbf7d0; border-radius:10px; padding:10px 14px;">
        <div style="display:flex; align-items:center; gap:8px;">
          <span style="width:8px;height:8px;border-radius:50%;background:#16a34a;display:inline-block;"></span>
          <span style="font-weight:700; color:#15803d;">P&L Sheet</span>
        </div>
        <span style="font-weight:600; color:#14532d; font-family:monospace;">
         ${dayjs(PLDateRange?.[1]).format("DD-MM-YYYY")}
          &nbsp;→&nbsp;
         ${dayjs(PLDateRange?.[0]).format("DD-MM-YYYY")}
        </span>
      </div>

      <div style="border-top:1px dashed #e2e8f0; margin:2px 0;"></div>

      <div style="display:flex; align-items:center; justify-content:space-between; background:#fefce8; border:1px solid #fde68a; border-radius:10px; padding:10px 14px;">
        <div style="display:flex; align-items:center; gap:8px;">
          <span style="width:8px;height:8px;border-radius:50%;background:#f59e0b;display:inline-block;box-shadow:0 0 0 2px #fde68a;"></span>
          <span style="font-weight:700; color:#92400e;">Showing Data</span>
        </div>
        <span style="font-weight:700; color:#78350f; font-family:monospace;">
          ${finalRange[0].format("DD-MM-YYYY")}
          &nbsp;→&nbsp;
          ${finalRange[1].format("DD-MM-YYYY")}
        </span>
      </div>

    </div>
  `,
          confirmButtonText: "Got it",
          confirmButtonColor: "#3b82f6",
        })

        if (finalRange) {
          fetchInitialData(finalRange)
        }
      }
    }

    // Call the API directly here with the values we just read
    const fetchInitialData = async DateRange => {
      const APIdata = await FetchPostData(setLoading, "sheet/dashboard/data", {
        startDate: DateRange?.[0]?.format("YYYY-MM-DD"), // dayjs .format() works fine
        endDate: DateRange?.[1]?.format("YYYY-MM-DD"),
      })
      if (APIdata?.data?.success) {
        const salesAvg = APIdata?.data?.salesRevenue?.length
          ? APIdata.data.salesRevenue.reduce(
              (sum, item) => sum + Number(item.amount),
              0
            ) / APIdata.data.salesRevenue.length
          : 0

        setSales(salesAvg.toFixed(0))

        // GMP AVERAGE
        const gmpAvg = APIdata?.data?.gmp?.length
          ? APIdata?.data?.gmp.reduce(
              (sum, item) => sum + Number(item.score),
              0
            ) / APIdata?.data?.gmp.length
          : 0

        setGmp(gmpAvg.toFixed(0))

        // OEE AVERAGE
        const oeeAvg = APIdata?.data?.oee?.length
          ? APIdata?.data?.oee.reduce(
              (sum, item) => sum + Number(item.efficiency),
              0
            ) / APIdata?.data?.oee.length
          : 0

        setOee(oeeAvg.toFixed(0))

        // PL Guage
        const PL = APIdata?.data?.profitLoss?.length
          ? APIdata?.data?.profitLoss.reduce(
              (sum, item) => sum + Number(item.sumGrossMargin),
              0
            )
          : // ) / APIdata?.data?.profitLoss.length
            0

        setPL(PL.toFixed(0))

        // NetPL Guage
        const NetPL = APIdata?.data?.profitLoss?.length
          ? APIdata?.data?.profitLoss.reduce(
              (sum, item) => sum + Number(item.sumNetMarginContribution),
              0
            ) / APIdata?.data?.profitLoss.length
          : // ) / APIdata?.data?.profitLoss.length
            0

        setNetPL(APIdata?.data?.finalNetMargin?.toFixed(0))
        setDashboardData1(APIdata?.data)
      } else {
        Swal.fire({
          title: "Error Fetching Charts",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }

    currentWeekDate()
  }, [])

  useEffect(() => {
    fetchRanges()
  }, [])

  async function fetchRanges() {
    const APIdata = await fetchData(setLoading, "gauge/ranges")
    if (APIdata?.success) {
      setRanges(APIdata?.data)
    } else {
      Swal.fire({
        title: "Error Fetching Ranges",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  async function getDashboardCharts() {
    if (dateRange?.length > 0) {
      const startDate = dateRange[0]
      const endDate = dateRange[1]
      const daysDiff = endDate.diff(startDate, "days") + 1

      let message = ""

      if (daysDiff <= 7) {
        // Single week
        message = `Selected date range shows data from ${startDate.format(
          "D"
        )} - ${endDate.format("D MMM YYYY")}`
      } else {
        // Multiple weeks - calculate week ranges
        const weeks = []
        let current = startDate.clone()

        while (
          current.isBefore(endDate, "day") ||
          current.isSame(endDate, "day")
        ) {
          const weekEnd = current.clone().add(6, "days")
          const actualEnd = weekEnd.isAfter(endDate) ? endDate.clone() : weekEnd

          weeks.push(
            `${current.format("D MMM")} - ${actualEnd.format("D MMM YYYY")}`
          )

          current = weekEnd.clone().add(1, "days")
        }

        const weekCount = weeks.length
        const weekList = weeks
          .map((w, i) => `<b>Week ${i + 1}:</b> ${w}`)
          .join("<br/>")

        message = `Your selection spans <b>${weekCount} week${
          weekCount > 1 ? "s" : ""
        }</b> of data:<br/><br/>${weekList}`
      }

      await Swal.fire({
        title: "Date Range Info",
        html: message,
        icon: "info",
      })
    }

    if (selectedMonths.length && !selectedYears?.length) {
      Swal.fire({
        title: "Year Not Seleted",
        text: "Current Year Will be Shown Bydefualt",
        icon: "info",
      })
    }

    const APIdata = await FetchPostData(setLoading, "sheet/dashboard/data", {
      startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
      endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
      month: selectedMonths?.map(item => item?.value)?.join(","),
      year: selectedYears?.map(item => item?.value)?.join(","),
    })
    if (APIdata?.data?.success) {
      const salesAvg = APIdata?.data?.salesRevenue?.length
        ? APIdata.data.salesRevenue.reduce(
            (sum, item) => sum + Number(item.amount),
            0
          ) / APIdata.data.salesRevenue.length
        : 0

      setSales(salesAvg.toFixed(0))

      // GMP AVERAGE
      const gmpAvg = APIdata?.data?.gmp?.length
        ? APIdata?.data?.gmp.reduce(
            (sum, item) => sum + Number(item.score),
            0
          ) / APIdata?.data?.gmp.length
        : 0

      setGmp(gmpAvg.toFixed(0))

      // OEE AVERAGE
      const oeeAvg = APIdata?.data?.oee?.length
        ? APIdata?.data?.oee.reduce(
            (sum, item) => sum + Number(item.efficiency),
            0
          ) / APIdata?.data?.oee.length
        : 0

      setOee(oeeAvg.toFixed(0))

      // PL Guage
      const PL = APIdata?.data?.profitLoss?.length
        ? APIdata?.data?.profitLoss.reduce(
            (sum, item) => sum + Number(item.sumGrossMargin),
            0
          )
        : // ) / APIdata?.data?.profitLoss.length
          0

      setPL(PL.toFixed(0))

      // NetPL Guage
      const NetPL = APIdata?.data?.profitLoss?.length
        ? APIdata?.data?.profitLoss.reduce(
            (sum, item) => sum + Number(item.sumNetMarginContribution),
            0
          ) / APIdata?.data?.profitLoss.length
        : // ) / APIdata?.data?.profitLoss.length
          0

      setNetPL(APIdata?.data?.finalNetMargin?.toFixed(0))
      getDashboardCharts1()
    } else {
      Swal.fire({
        title: "Error Fetching Charts",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  async function getDashboardCharts1() {
    if (selectedMonths.length && !selectedYears?.length) {
      Swal.fire({
        title: "Year Not Seleted",
        text: `Current Year Will be Shown By default : ${moment()?.year()}`,
        icon: "info",
      })
    }
    const APIdata = await FetchPostData(setLoading, "sheet/dashboard/data", {
      startDate: dateRange1?.[0]?.format("YYYY-MM-DD"),
      endDate: dateRange1?.[1]?.format("YYYY-MM-DD"),
      month: selectedMonths1?.map(item => item?.value)?.join(","),
      year: selectedYears1?.map(item => item?.value)?.join(","),
    })
    if (APIdata?.data?.success) {
      setDashboardData1(APIdata?.data)
    } else {
      Swal.fire({
        title: "Error Fetching Charts",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleSheetImport = async () => {
    if (!importFile) {
      setError("Please Select CSV file.")
      return
    }

    const APIdata = await FetchPostData(setLoading, "sheet", {
      sheet: importFile,
      type: selectedType,
    })

    if (APIdata?.data?.success) {
      const logs = APIdata?.data?.logs

      let swalHtml = ""

      if (selectedType === "costings") {
        // ── Profit & Loss response structure ──
        const processedCount = logs?.processedCount ?? 0
        const skippedRows = logs?.skippedRows ?? 0
        const failedSheetNames = logs?.failedSheetNames || []
        const rowWarnings = logs?.rowWarnings || []

        swalHtml = `
      <div style="text-align:left; font-size:13px;">

        <!-- Summary Bar -->
        <div style="
          display:flex; gap:10px; margin-bottom:14px;
          background:#f8f9fa; border-radius:10px; padding:10px 14px;
        ">
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#198754;">${processedCount}</div>
            <div style="font-size:11px; color:#666;">Rows Processed</div>
          </div>
          <div style="width:1px; background:#dee2e6;"></div>
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#dc3545;">${skippedRows}</div>
            <div style="font-size:11px; color:#666;">Rows Skipped</div>
          </div>
          <div style="width:1px; background:#dee2e6;"></div>
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#f59e0b;">${
              rowWarnings.length
            }</div>
            <div style="font-size:11px; color:#666;">Warnings</div>
          </div>
        </div>

        <!-- Failed Sheets -->
        ${
          failedSheetNames.length > 0
            ? `
          <div style="font-size:11px; font-weight:700; color:#888; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:6px;">
            Failed Sheets
          </div>
          <div style="
            max-height:120px; overflow-y:auto;
            border:1px solid #f5c2c7; border-radius:8px;
            padding:4px 0; margin-bottom:10px;
          ">
            ${failedSheetNames
              .map(
                (name, i) => `
              <div style="
                display:flex; align-items:center; gap:8px;
                padding:7px 14px;
                background:${i % 2 === 0 ? "#fff5f5" : "#fff"};
              ">
                <span style="color:#dc3545; font-size:12px;">✕</span>
                <span style="color:#444; font-weight:600;">${name}</span>
              </div>`
              )
              .join("")}
          </div>`
            : ""
        }

        <!-- Row Warnings -->
        ${
          rowWarnings.length > 0
            ? `
          <div style="font-size:11px; font-weight:700; color:#888; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:6px;">
            Row Warnings
          </div>
          <div style="
            max-height:160px; overflow-y:auto;
            border:1px solid #ffe082; border-radius:8px;
            padding:4px 0; margin-bottom:10px;
          ">
            ${rowWarnings
              .map(
                (msg, i) => `
              <div style="
                display:flex; align-items:flex-start; gap:8px;
                padding:7px 14px;
                background:${i % 2 === 0 ? "#fffdf0" : "#fff"};
              ">
                <span style="color:#f59e0b; font-size:12px; margin-top:1px;">⚠</span>
                <span style="color:#555; font-size:12px;">${msg}</span>
              </div>`
              )
              .join("")}
          </div>`
            : `
          <div style="
            background:#f0fff4; border:1px solid #b7ebc4;
            border-radius:8px; padding:8px 12px;
            font-size:12px; color:#166534;
          ">
            ✅ No warnings — all rows processed cleanly.
          </div>`
        }

      </div>
    `
      } else {
        // ── KPI response structure ──
        const imported = logs?.imported || {}
        const warnings = logs?.warnings ?? 0
        const totalImported = Object.values(imported).reduce((a, b) => a + b, 0)

        swalHtml = `
      <div style="text-align:left; font-size:13px;">

        <!-- Summary Bar -->
        <div style="
          display:flex; gap:10px; margin-bottom:14px;
          background:#f8f9fa; border-radius:10px; padding:10px 14px;
        ">
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#198754;">${totalImported}</div>
            <div style="font-size:11px; color:#666;">Total Imported</div>
          </div>
          <div style="width:1px; background:#dee2e6;"></div>
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#f59e0b;">${warnings}</div>
            <div style="font-size:11px; color:#666;">Warnings</div>
          </div>
          <div style="width:1px; background:#dee2e6;"></div>
          <div style="flex:1; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:#4361ee;">${
              Object.keys(imported).length
            }</div>
            <div style="font-size:11px; color:#666;">Modules</div>
          </div>
        </div>

        <!-- Imported Breakdown -->
        <div style="font-size:11px; font-weight:700; color:#888; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:6px;">
          Imported Records
        </div>

        <div style="
          max-height:260px; overflow-y:auto;
          border:1px solid #e9ecef; border-radius:8px;
          padding:4px 0;
        ">
          ${Object.entries(imported)
            .map(
              ([key, val], i) => `
            <div style="
              display:flex; justify-content:space-between; align-items:center;
              padding:7px 14px;
              background:${i % 2 === 0 ? "#fff" : "#f8f9fa"};
            ">
              <span style="color:#444; font-weight:600; text-transform:capitalize;">
                ${key.replace(/([A-Z])/g, " $1").trim()}
              </span>
              <span style="
                background:#e8f5e9; color:#198754;
                font-weight:700; font-size:12px;
                padding:2px 10px; border-radius:20px;
              ">
                ${val} rows
              </span>
            </div>`
            )
            .join("")}
        </div>

        ${
          warnings > 0
            ? `<div style="
                margin-top:10px;
                background:#fff8e1; border:1px solid #ffe082;
                border-radius:8px; padding:8px 12px;
                font-size:12px; color:#92400e;
              ">
                ⚠️ <strong>${warnings} warning(s)</strong> were encountered during import. Please review the data.
              </div>`
            : ""
        }

      </div>
    `
      }

      Swal.fire({
        title: "Sheet Imported Successfully",
        icon: "success",
        width: 520,
        html: swalHtml,
      })

      setImportModal(false)
      setImportFile(null)
      fileInputRef.current.value = ""
    } else {
      Swal.fire({
        title: "Error Importing Sheet",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const [activeChart, setActiveChart] = useState(null)
  const [chartModal, setChartModal] = useState({ open: false, type: null })

  // Refs for each chart section
  const gaugeRef = useRef(null)
  const salesRef = useRef(null)
  const gmpRef = useRef(null)
  const oeeRef = useRef(null)
  const plRef = useRef(null)

  const scrollToChart = type => {
    setActiveChart(type)
    const refMap = {
      sales: salesRef,
      gmp: gmpRef,
      oee: oeeRef,
      pl: plRef,
    }
    refMap[type]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    })

    // Remove highlight after 2.5s
    setTimeout(() => setActiveChart(null), 2500)
  }

  const openChartModal = type => setChartModal({ open: true, type })
  const closeChartModal = () => setChartModal({ open: false, type: null })

  const dashboardRef = useRef(null)

  const handleExport = async () => {
    const element = dashboardRef.current
    if (!element) return

    try {
      setLoading(true)

      const originalHeight = element.style.height
      const originalOverflow = element.style.overflow
      element.style.height = "auto"
      element.style.overflow = "visible"

      // ✅ Get the element's actual position on the page
      const rect = element.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const elementTop = rect.top + scrollTop // absolute top position of dashboardRef

      const canvas = await html2canvas(element, {
        scale: 1.2,
        useCORS: true,
        allowTaint: true,
        scrollX: 0,
        scrollY: -scrollTop, // ✅ This corrects the scroll offset
        y: 0, // ✅ Start capturing from top of the element itself
        x: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        logging: false,
      })

      element.style.height = originalHeight
      element.style.overflow = originalOverflow

      const imgData = canvas.toDataURL("image/jpeg", 0.75)

      const imgWidth = canvas.width / 1.2
      const imgHeight = canvas.height / 1.2

      const marginLeft = 30
      const marginRight = 30
      const marginTop = 10
      const marginBottom = 20

      const pdfWidth = imgWidth + marginLeft + marginRight
      const pdfHeight = imgHeight + marginTop + marginBottom

      const pdf = new jsPDF({
        orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
        unit: "px",
        format: [pdfWidth, pdfHeight],
        compress: true,
      })

      pdf.addImage(
        imgData,
        "JPEG",
        marginLeft,
        marginTop,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      )

      pdf.save(
        `Dashboard_${new Date()
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-")}.pdf`
      )
    } catch (e) {
      Swal.fire({
        title: "Export Failed",
        text: "Something went wrong while exporting.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  const [longchartModal, setLongChartModal] = useState(false)
  const [longType, setLongType] = useState("")

  return (
    <React.Fragment>
      {loading && <Loader />}

      <div className="page-content" ref={dashboardRef}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
            padding: "18px 24px",
            marginBottom: "24px",
            position: "relative",
            overflow: "visible",
            boxShadow:
              "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
          }}
        >
          <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
            {/* ── LEFT: Title + Week badge + Export ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                flexWrap: "wrap",
              }}
            >
              {/* Title + subtitle */}
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "#0f172a",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Dashboard
                </h4>
              </div>

              {/* Divider */}
              <div
                style={{ width: "1px", height: "36px", background: "#e2e8f0" }}
              />

              {/* Export button */}
              <Button
                onClick={handleExport}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  background: "#0f172a",
                  border: "none",
                  borderRadius: "10px",
                  padding: "8px 16px",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#fff",
                  cursor: "pointer",
                  letterSpacing: "0.2px",
                }}
              >
                <MdDownload size={15} />
                Export
              </Button>

              {/* Latest week badge */}
              {currentweek?.[0] && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    borderRadius: "10px",
                    padding: "6px 12px",
                  }}
                >
                  <span
                    style={{
                      width: "7px",
                      height: "7px",
                      borderRadius: "50%",
                      background: "#16a34a",
                      display: "inline-block",
                      boxShadow: "0 0 0 2px #bbf7d0",
                    }}
                  />
                  <div>
                    <div
                      style={{
                        fontSize: "10px",
                        color: "#15803d",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.6px",
                      }}
                    >
                      Latest week Upload
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#166534",
                        fontWeight: 600,
                        marginTop: "1px",
                      }}
                    >
                      {currentweek[0].format("DD MMM")} —{" "}
                      {currentweek[1].format("DD MMM YYYY")}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* ── RIGHT: Filters ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <RangePicker
                value={dateRange}
                placeholder={["Start (Sat)", "End (Fri)"]}
                onChange={values => {
                  setDateRange(values)
                  setDateRange1(values)
                  secureLocalStorage?.setItem("DateRange", values)
                }}
                format="DD-MM-YYYY"
                disabledDate={current => {
                  return current && current > maxDate.endOf("day")
                }}
              />

              <Select
                placeholder="Month"
                options={months}
                styles={{
                  ...customStyles,
                  control: base => ({
                    ...base,
                    borderRadius: "8px",
                    minHeight: "36px",
                    height: "36px",
                    fontSize: "13px",
                    borderColor: "#e2e8f0",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#cbd5e1" },
                  }),
                }}
                isMulti
                value={selectedMonths}
                onChange={v => {
                  setSelectedMonths(v)
                  setSelectedMonths1(v)
                  secureLocalStorage?.setItem("Months", v)
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />

              <Select
                placeholder="Year"
                options={years}
                styles={{
                  ...customStyles,
                  control: base => ({
                    ...base,
                    borderRadius: "8px",
                    minHeight: "36px",
                    height: "36px",
                    fontSize: "13px",
                    borderColor: "#e2e8f0",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#cbd5e1" },
                  }),
                }}
                isMulti
                value={selectedYears}
                onChange={v => {
                  setSelectedYears(v)
                  setSelectedYears1(v)
                  secureLocalStorage?.setItem("Years", v)
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />

              {/* Apply filter button */}
              <button
                onClick={getDashboardCharts}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "5px",
                  background: "#3b82f6",
                  border: "none",
                  borderRadius: "8px",
                  padding: "0 14px",
                  height: "36px",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 700,
                  cursor: "pointer",
                  letterSpacing: "0.3px",
                  whiteSpace: "nowrap",
                }}
              >
                <FaFilter size={10} />
              </button>

              {/* Divider */}
              <div
                style={{ width: "1px", height: "24px", background: "#e2e8f0" }}
              />

              {/* Import dropdown */}
              <Dropdown
                isOpen={importDropdown}
                toggle={() => setImportDropdown(!importDropdown)}
              >
                <DropdownToggle
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "0 14px",
                    height: "36px",
                    color: "#374151",
                    fontSize: "12px",
                    fontWeight: 700,
                    cursor: "pointer",
                    letterSpacing: "0.3px",
                  }}
                >
                  <MdImportExport size={15} style={{ color: "#6366f1" }} />
                  Import
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    style={{ marginLeft: "2px" }}
                  >
                    <path
                      d="M2 3.5L5 6.5L8 3.5"
                      stroke="#94a3b8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </DropdownToggle>

                <DropdownMenu
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
                    padding: "6px",
                    minWidth: "180px",
                  }}
                >
                  <DropdownItem
                    onClick={() => {
                      setSelectedType("kpi")
                      setImportModal(true)
                    }}
                    style={{
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: 500,
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "#1e293b",
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "8px",
                        background: "#eff6ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MdReport size={14} color="#3b82f6" />
                    </div>
                    KPI Sheet
                  </DropdownItem>

                  <DropdownItem
                    onClick={() => {
                      setSelectedType("costings")
                      setImportModal(true)
                    }}
                    style={{
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: 500,
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "#1e293b",
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "8px",
                        background: "#f0fdf4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MdCurrencyPound size={14} color="#16a34a" />
                    </div>
                    Profit & Loss
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div ref={gaugeRef}>
          <Row className="g-3 mb-3">
            {" "}
            {/* ✅ stretch + gap */}
            <Col xl={3}>
              <div
                style={{ position: "relative", height: "100%" }}
                className="bg-white rounded-4"
              >
                {" "}
                {/* ✅ */}
                <button
                  onClick={() => openChartModal("gmp")}
                  title="Expand GMP chart"
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    background: "rgba(255,255,255,0.85)",
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "3px 7px",
                    cursor: "pointer",
                    fontSize: "13px",
                    lineHeight: 1,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  ⛶
                </button>
                <div
                  onClick={() => {
                    setLongChartModal(true), setLongType("gmp")
                  }}
                  style={{ cursor: "pointer", height: "100%", padding: "15px" }}
                >
                  {" "}
                  {/* ✅ */}
                  <Gauge
                    min={ranges?.[1]?.start}
                    value={gmp}
                    name="GMP (Good Manufacturing Practice)"
                    max={ranges?.[1]?.max}
                    formatValue={v => `${v} %`}
                    ranges={[
                      { limit: ranges?.[1]?.min, color: "#ff3b30" },
                      { limit: ranges?.[1]?.mid, color: "#ffcc00" },
                      { limit: ranges?.[1]?.max, color: "#34c759" },
                    ]}
                    type={dashboardData1?.gmp?.length > 1 ? "Average" : "Sum"}
                  />
                </div>
              </div>
            </Col>
            <Col xl={3}>
              {" "}
              {/* ← fixed height here */}
              <div
                style={{ position: "relative", height: "100%" }}
                className="bg-white rounded-4"
              >
                <button
                  onClick={() => openChartModal("sales")}
                  title="Expand Sales Revenue chart"
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    background: "rgba(255,255,255,0.85)",
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "3px 7px",
                    cursor: "pointer",
                    fontSize: "13px",
                    lineHeight: 1,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  ⛶
                </button>

                <div
                  onClick={() => {
                    setLongChartModal(true), setLongType("sales")
                  }}
                  style={{ cursor: "pointer", height: "100%", padding: "15px" }}
                >
                  <Gauge
                    min={ranges?.[0]?.start}
                    value={sales}
                    name="Sales Revenue"
                    max={ranges?.[0]?.max}
                    formatValue={v =>
                      new Intl.NumberFormat("en-GB", {
                        style: "currency",
                        currency: "GBP",
                        maximumFractionDigits: 0,
                      }).format(v)
                    }
                    ranges={[
                      { limit: ranges?.[0]?.min, color: "#ff3b30" },
                      { limit: ranges?.[0]?.mid, color: "#ffcc00" },
                      { limit: ranges?.[0]?.max, color: "#34c759" },
                    ]}
                    formatTickLabel={value => {
                      const sign = value < 0 ? "-£ " : "£ "
                      const absValue = Math.abs(value)
                      return absValue >= 1000
                        ? `${sign}${Math.round(absValue / 1000)}K`
                        : `${sign}${absValue}`
                    }}
                    newTickLabel={true}
                    type={
                      dashboardData1?.profitLoss?.length > 1 ? "Average" : "Sum"
                    }
                  />
                </div>
              </div>
            </Col>
            <Col xl={3}>
              <div
                style={{ position: "relative", height: "100%" }}
                className="bg-white rounded-4"
              >
                {" "}
                {/* ✅ */}
                <button
                  onClick={() => openChartModal("oee")}
                  title="Expand OEE chart"
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    background: "rgba(255,255,255,0.85)",
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "3px 7px",
                    cursor: "pointer",
                    fontSize: "13px",
                    lineHeight: 1,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  ⛶
                </button>
                <div
                  onClick={() => {
                    setLongChartModal(true), setLongType("oee")
                  }}
                  style={{ cursor: "pointer", height: "100%", padding: "15px" }}
                >
                  {" "}
                  {/* ✅ */}
                  <Gauge
                    min={ranges?.[2]?.start}
                    value={oee}
                    name="OEE (Overall Equipment Effectiveness)"
                    max={ranges?.[2]?.max}
                    formatValue={v => `${v} %`}
                    formatTickLabel={value => `${value} %`}
                    newTickLabel={true}
                    ranges={[
                      { limit: ranges?.[2]?.min, color: "#ff3b30" },
                      { limit: ranges?.[2]?.mid, color: "#ffcc00" },
                      { limit: ranges?.[2]?.max, color: "#34c759" },
                    ]}
                    type={dashboardData1?.oee?.length > 1 ? "Average" : "Sum"}
                  />
                </div>
              </div>
            </Col>
            <Col xl={3}>
              <div
                className="bg-white  overflow-hidden shadow rounded-4"
                style={{ position: "relative", height: "100%" }}
              >
                <button
                  onClick={() => openChartModal("pl")}
                  title="Expand Net Margin chart"
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 15,
                    zIndex: 10,
                    background: "rgba(255,255,255,0.85)",
                    border: "1px solid #e0e0e0",
                    borderRadius: "6px",
                    padding: "3px 7px",
                    cursor: "pointer",
                    fontSize: "13px",
                    lineHeight: 1,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  ⛶
                </button>
                <div
                  onClick={() => {
                    setLongChartModal(true), setLongType("pl")
                  }}
                  style={{ cursor: "pointer", height: "100%", padding: "15px" }}
                >
                  <Gauge
                    value={netPL}
                    name="Net Margin"
                    min={ranges?.[4]?.start}
                    max={ranges?.[4]?.max}
                    formatValue={v =>
                      new Intl.NumberFormat("en-GB", {
                        style: "currency",
                        currency: "GBP",
                        maximumFractionDigits: 0,
                      }).format(v)
                    }
                    ranges={[
                      { limit: ranges?.[4]?.min, color: "#ff3b30" },
                      { limit: ranges?.[4]?.mid, color: "#ffcc00" },
                      { limit: ranges?.[4]?.max, color: "#34c759" },
                    ]}
                    formatTickLabel={value => {
                      const sign = value < 0 ? "-£ " : "£ "
                      const absValue = Math.abs(value)
                      return absValue >= 1000
                        ? `${sign}${Math.round(absValue / 1000)}K`
                        : `${sign}${absValue}`
                    }}
                    newTickLabel={true}
                    type={
                      dashboardData1?.profitLoss?.length > 1 ? "Average" : "Sum"
                    }
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* ── Formula Banner ── */}
        <div
          className="mb-4"
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            padding: "14px 16px",
            marginBottom: "8px",
            boxShadow:
              "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
            display: "flex",
            alignItems: "center",
          }}
        >
          {[
            {
              label: "Our People",
              Icon: FaUsers,
              iconBg: "#eff6ff",
              iconColor: "#3b82f6",
              sub: "GMP",
              opColor: "#94a3b8",
            },
            {
              label: "Our Product",
              Icon: FaBoxOpen,
              iconBg: "#f0fdf4",
              iconColor: "#22c55e",
              sub: "Sales Revenue",
              opColor: "#94a3b8",
            },
            {
              label: "Our Efficiency",
              Icon: MdSpeed,
              iconBg: "#fffbeb",
              iconColor: "#f59e0b",
              sub: "OEE",
              opColor: "#94a3b8",
            },
            {
              label: "Our Result",
              Icon: MdCurrencyPound,
              iconBg: "#fdf4ff",
              iconColor: "#a855f7",
              sub: "Net Margin",
              isResult: true,
              opColor: "#a855f7",
            },
          ].map((item, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <div
                  style={{ flexShrink: 0, textAlign: "center", width: "40px" }}
                >
                  <span
                    style={{
                      fontSize: "22px",
                      fontWeight: 800,
                      color: item.opColor,
                    }}
                  >
                    {item.isResult ? "=" : "+"}
                  </span>
                </div>
              )}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  background: item.isResult ? "#fdf4ff" : "#f8fafc",
                  border: `1px solid ${item.isResult ? "#e9d5ff" : "#f1f5f9"}`,
                  borderRadius: "12px",
                  padding: "12px 16px",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: item.iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <item.Icon size={20} color={item.iconColor} />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#0f172a",
                      lineHeight: 1.2,
                    }}
                  >
                    {item.label}
                  </div>
                  {/* <div
                    style={{
                      fontSize: "11px",
                      color: "#94a3b8",
                      fontWeight: 500,
                      marginTop: "3px",
                    }}
                  >
                    {item.sub}
                  </div> */}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
        {/*  */}
      </div>

      {/* FILE IMPORT MODAL */}
      <Modal isOpen={importModal} toggle={() => setImportModal(false)} centered>
        <ModalHeader toggle={() => setImportModal(false)}>
          Import Excel Sheet
        </ModalHeader>
        <ModalBody>
          <Label>
            Select File <span className="text-danger">*</span>
          </Label>

          <Input
            type="file"
            innerRef={fileInputRef}
            accept=".xlsx,.xls,.csv"
            onChange={e => setImportFile(e.target.files[0])}
          />
          {error && <span className="text-danger">* {error}</span>}

          <div className="d-flex justify-content-start gap-3 mt-3">
            <Button className="bg-blue" onClick={() => handleSheetImport()}>
              <FaFileImport className="me-2" /> Import
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={chartModal.open}
        toggle={closeChartModal}
        centered
        size="lg"
      >
        <ModalHeader
          toggle={closeChartModal}
          style={{
            color: "#000",
            borderBottom: "1px solid #e8e8f0",
            fontWeight: 700,
            fontSize: "15px",
          }}
          className="text-dark"
        >
          {chartModal.type === "sales" && "📈 Sales Revenue — Detailed View"}
          {chartModal.type === "gmp" && "🏭 GMP — Good Manufacturing Practice"}
          {chartModal.type === "oee" &&
            "⚙️ OEE — Overall Equipment Effectiveness"}
          {chartModal.type === "pl" && "💷 Profit & Loss — Net Margin"}
        </ModalHeader>
        <ModalBody style={{ padding: "24px", background: "#fff" }}>
          {chartModal.type === "sales" && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "32px" }}
            >
              <Gauge
                min={ranges?.[0]?.start}
                value={sales}
                name="Sales Revenue"
                max={ranges?.[0]?.max}
                formatValue={v =>
                  new Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "GBP",
                    maximumFractionDigits: 0,
                  }).format(v)
                }
                ranges={[
                  { limit: ranges?.[0]?.min, color: "#ff3b30" },
                  { limit: ranges?.[0]?.mid, color: "#ffcc00" },
                  { limit: ranges?.[0]?.max, color: "#34c759" },
                ]}
                formatTickLabel={value => {
                  const sign = value < 0 ? "-£ " : "£ "
                  const absValue = Math.abs(value)
                  return absValue >= 1000
                    ? `${sign}${Math.round(absValue / 1000)}K`
                    : `${sign}${absValue}`
                }}
                newTickLabel={true}
              />
            </div>
          )}

          {chartModal.type === "gmp" && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "32px" }}
            >
              <Gauge
                min={ranges?.[1]?.start}
                value={gmp}
                name="GMP (Good Manufacturing Practice)"
                max={ranges?.[1]?.max}
                width={600}
                formatValue={v => `${v} %`}
                ranges={[
                  { limit: ranges?.[1]?.min, color: "#ff3b30" },
                  { limit: ranges?.[1]?.mid, color: "#ffcc00" },
                  { limit: ranges?.[1]?.max, color: "#34c759" },
                ]}
              />
            </div>
          )}

          {chartModal.type === "oee" && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "32px" }}
            >
              <Gauge
                min={ranges?.[2]?.start}
                value={oee}
                width={600}
                name="OEE (Overall Equipment Effectiveness)"
                max={ranges?.[2]?.max}
                formatValue={v => `${v} %`}
                formatTickLabel={value => `${value} %`}
                newTickLabel={true}
                ranges={[
                  { limit: ranges?.[2]?.min, color: "#ff3b30" },
                  { limit: ranges?.[2]?.mid, color: "#ffcc00" },
                  { limit: ranges?.[2]?.max, color: "#34c759" },
                ]}
              />
            </div>
          )}

          {chartModal.type === "pl" && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "32px" }}
            >
              <Gauge
                value={netPL}
                min={ranges?.[4]?.start}
                name="Net Margin"
                width={600}
                max={ranges?.[4]?.max}
                formatValue={v =>
                  new Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "GBP",
                    maximumFractionDigits: 0,
                  }).format(v)
                }
                ranges={[
                  { limit: ranges?.[4]?.min, color: "#ef4444" },
                  { limit: ranges?.[4]?.mid, color: "#f59e0b" },
                  { limit: ranges?.[4]?.max, color: "#10b981" },
                ]}
                formatTickLabel={value => {
                  const sign = value < 0 ? "-£ " : "£ "
                  const absValue = Math.abs(value)
                  return absValue >= 1000
                    ? `${sign}${Math.round(absValue / 1000)}K`
                    : `${sign}${absValue}`
                }}
                newTickLabel={true}
              />
            </div>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={longchartModal} fullscreen>
        <ModalHeader
          toggle={() => setLongChartModal(false)}
          className="text-white"
        >
          {longType === "pl"
            ? "Net Margin History"
            : longType === "oee"
            ? "OEE — (Overall Equipment Effectiveness) History"
            : longType === "sales"
            ? "Sales Revenue History"
            : "GMP — (Good Manufacturing Practice) History"}
        </ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column flex-xl-row align-items-center justify-content-end mb-3">
            <div className="d-flex flex-column flex-xl-row gap-3">
              <RangePicker
                value={dateRange1}
                placeholder={["Start (Sat)", "End (Fri)"]}
                onChange={values => {
                  setDateRange1(values)
                }}
                format="DD-MM-YYYY"
              />
              <Select
                placeholder="Select Month"
                options={months}
                value={selectedMonths1}
                styles={customStyles}
                isMulti
                onChange={v => setSelectedMonths1(v)}
              />

              <Select
                placeholder="Select Year"
                options={years?.reverse()}
                styles={customStyles}
                value={selectedYears1}
                isMulti
                onChange={v => {
                  if (v && v.length > 2) {
                    Swal.fire({
                      title: "Limit Reached",
                      text: "You can select a maximum of 2 years.",
                      icon: "warning",
                      timer: 1500,
                      showConfirmButton: false,
                    })
                    return
                  }
                  setSelectedYears1(v)
                }}
              />

              <Button className="bg-blue" onClick={() => getDashboardCharts1()}>
                <FaFilter />
              </Button>
            </div>
          </div>
          <Card>
            <CardBody>
              {longType === "pl" && (
                <OrderBarChart
                  data={dashboardData1?.finalNetMarginFirstYear}
                  maxValue={ranges?.[4]?.max}
                  previousData={dashboardData1?.finalNetMarginSecondYear}
                />
              )}
              {longType === "oee" && (
                <SalesChart
                  data={dashboardData1?.oee}
                  previousData={dashboardData1?.oeePreviousYear}
                />
              )}
              {longType === "gmp" && (
                <BarChart
                  data={dashboardData1?.gmp}
                  previousData={dashboardData1?.gmpPreviousYear}
                  closeOut={dashboardData1?.closeOut}
                  closeOutPreviousYear={dashboardData1?.closeOutPreviousYear}
                />
              )}
              {longType === "sales" && (
                <SuccessRateChart
                  data={dashboardData1?.salesRevenue}
                  previousData={dashboardData1?.salesRevenuePreviousYear}
                  maxValue={ranges?.[0]?.max}
                />
              )}
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Dashboard)
